import type { CSSProperties, ReactNode } from 'react';
import { MainMiniappBottomNav, type MainMiniappRoute } from '@miniapp-core/components';
import { MiniappPage } from '@miniapp-core/ui-kit';

interface RootMiniappShellProps {
  children: ReactNode;
  activeRoute?: MainMiniappRoute | undefined;
  hasMiniPlayer?: boolean;
}

export default function RootMiniappShell({
  children,
  activeRoute,
  hasMiniPlayer = false,
}: RootMiniappShellProps) {
  const hasBottomNavigation = Boolean(activeRoute);
  const overlayOffset = hasBottomNavigation
    ? hasMiniPlayer
      ? 'calc(var(--bottom-nav-height) + var(--mini-player-height) + var(--safe-area-bottom))'
      : 'calc(var(--bottom-nav-height) + var(--safe-area-bottom))'
    : '0px';

  return (
    <MiniappPage
      hasBottomNavigation={hasBottomNavigation}
      hasMiniPlayer={hasMiniPlayer}
      className="relative isolate [&>.dm-discovery-page]:min-h-0 [&>main]:min-h-0"
      style={{ '--miniapp-overlay-offset': overlayOffset } as CSSProperties}
    >
      {children}
      {activeRoute ? <MainMiniappBottomNav activeRoute={activeRoute} /> : null}
    </MiniappPage>
  );
}
